module.exports = "<div ng-include=\"$ctrl.template\"></div>\n"